import { defineMessages } from 'react-intl';

export const scope = 'app.components.StateDropdown';

export default defineMessages({
  stateError: {
    id: `${scope}.stateError`,
    defaultMessage: 'Please select a state'
  },
  provinceError: {
    id: `${scope}.provinceError`,
    defaultMessage: 'Please select a province'
  }
});
